import { createTheme } from '@mui/material/styles';

const lightPalette = {
  mode: 'light',
  background: {
    default: '#f6f8fa',
    paper: '#ffffff',
  },
  primary: { main: '#0969da' },
  error: { main: '#d1242f' },
  warning: { main: '#9a6700' },
  info: { main: '#0550ae' },
  success: { main: '#1a7f37' },
  text: {
    primary: '#1f2328',
    secondary: '#636c76',
    disabled: '#8c959f',
  },
  divider: '#d0d7de',
};

const darkPalette = {
  mode: 'dark',
  background: {
    default: '#0d1117',
    paper: '#161b22',
  },
  primary: { main: '#58a6ff' },
  error: { main: '#e5534b' },
  warning: { main: '#d4a24e' },
  info: { main: '#388bfd' },
  success: { main: '#57ab5a' },
  text: {
    primary: '#e6edf3',
    secondary: '#8b949e',
  },
  divider: '#30363d',
};

export const createAppTheme = (prefersDark) =>
  createTheme({ palette: prefersDark ? darkPalette : lightPalette });
